import $ from 'jquery';

import {JOB_GOOGLE_MAP_ID, JOB_GOOGLE_MAP_BLUR_CLASS} from '../redux/actions/jobsActions';

export default function addBlurToGoogleMap() {
    $(JOB_GOOGLE_MAP_ID).addClass(JOB_GOOGLE_MAP_BLUR_CLASS);
}